module.exports = __webpack_public_path__ + "static/media/cat.8909de12.gif";